<template>
    <div>
        <toolbar-page title="Business rules" disable-icon>
            <template slot="buttons">
                <v-tooltip top color="primary">
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" @click="closeButtonClicked">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Close</span>
                </v-tooltip>
            </template>
        </toolbar-page>

        <v-card>
            <v-card-text>

                <v-container fluid pa-2>
                    <v-row dense class="justify-space-between">

                        <v-col cols="12">

                            <v-alert
                                    class="body-2"
                                    type="info"
                            >
                                You can temporarily disable business rules to see the impact on the match count.
                                By default all projects obey business rules at all times. Any segment that is flagged as a filter
                                by default omits business rules.
                            </v-alert>

<!--                            <segment-visualizer-->
<!--                                    :json-query="jsonQuery"-->
<!--                                    :json-filter="jsonFilter"-->
<!--                                    :show-business-rules="false"-->
<!--                                    :disable-sub-panel-filtering="true"-->
<!--                                    :editable="false"-->
<!--                                    title="Business Rules"-->
<!--                                    title-color="#F57F17"-->
<!--                                    title-icon="mdi-gavel"-->
<!--                                    empty-segment-warning="Business rules have not been setup!"-->
<!--                            ></segment-visualizer>-->

                        </v-col>

                        <v-col cols="4" class="align-self-center">

                            <v-btn v-show="activeModel"
                                   class="mt-2"
                                   @click="modified"
                                   color="red">
                                DISABLE BUSINESS RULES
                            </v-btn>

                            <v-btn v-show="!activeModel"
                                   class="mt-2"
                                   @click="modified"
                                   color="green">
                                ENABLE BUSINESS RULES
                            </v-btn>

                            <!--                            <v-btn small color="primary" @click="closeButtonClicked">Close</v-btn>-->
                        </v-col>

                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

    </div>
</template>

<script>

    import ToolbarPage from '../../../components/UI/ToolbarPage';

    // TODO: Creates circular reference
    //import SegmentVisualizer from "./SegmentVisualizer";

    export default {

        components: {
            ToolbarPage,
            //SegmentVisualizer
        },

        props: {
            active: {
                required: false,
                type: Boolean,
                default: false,
            },
            jsonQuery: {
                required: true,
                type: Object,
            },
            jsonFilter: {
                required: true,
                type: Object
            },
        },

        data() {
            return {
                activeModel: true,
            }
        },

        watch: {
            active(newValue) {
                this.activeModel = newValue;
            }
        },

        created() {
            this.activeModel = this.active;
        },

        methods: {
            closeButtonClicked() {
                this.$emit('close');
            },

            modified() {
                this.activeModel = !this.activeModel;
                this.$emit('change', this.activeModel);
            }
        }
    }
</script>
